import * as React from "react";
import { Icon, Intent } from "@blueprintjs/core";
import { getPasswordRequirementsStatus } from "utils";

interface PasswordRequirementsProps {
  password: string;
}

const PasswordRequirements: React.FC<PasswordRequirementsProps> = ({
  password,
}) => {
  const requirements = getPasswordRequirementsStatus(password);

  return (
    <div style={{ marginTop: "10px", marginBottom: "10px" }}>
      <div
        style={{
          fontSize: "12px",
          fontWeight: 600,
          marginBottom: "5px",
          color: "var(--neutral-4)",
        }}
      >
        Password Requirements:
      </div>
      <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
        {requirements.map((req) => (
          <li
            key={req.id}
            style={{
              display: "flex",
              alignItems: "center",
              fontSize: "12px",
              marginBottom: "3px",
              color: req.met ? "var(--success)" : "var(--neutral-4)",
            }}
          >
            <Icon
              icon={req.met ? "tick" : "dot"}
              intent={req.met ? Intent.SUCCESS : Intent.NONE}
              size={12}
              style={{ marginRight: "8px" }}
            />
            {req.label}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PasswordRequirements;
